const Partners = () => {
  // Partner logos - bisherige Kunden
  const partners = [
    { name: "Geiger Group / Identica", logo: "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/images/c26gv3uq-whatsapp-image-2025-04-10-at-19-53-55.jpeg" },
    { name: "Seedos", logo: "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/images/kzt7t893-seedos-logo.png" },
    { name: "Stadt Villingen-Schwenningen", logo: "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/images/j59guxlw-bildschirmfoto-2025-08-11-um-21-58-26.png" },
    // TODO: echte Kundennamen eintragen für besseres SEO
    { name: "Markenpartner", logo: "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/images/toeyvh3r-80906547-2220-44a9-9b92-acb3431c6421.avif" },
    { name: "Markenpartner", logo: "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/images/xwgyw8hc-fc68fde6-169e-4079-80d3-58e28ca8c2e4.avif" },
    { name: "Markenpartner", logo: "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/images/gexkpf86-ef20be1b-1143-41ce-8442-98f8cd08caa5.avif" },
    { name: "Markenpartner", logo: "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/images/j8yttyu7-3b15aa63-13f8-45ff-99ec-03023373404d.avif" },
  ];

  return (
    <section className="py-24 bg-secondary/30" data-testid="partners-section">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold mb-4" data-testid="partners-title">
            Bisherige Kunden
          </h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            Zusammenarbeit mit führenden Marken und Unternehmen
          </p>
        </div>

        {/* Logo Wall with Marquee */}
        <div className="relative overflow-hidden">
          <div className="flex gap-12 animate-marquee">
            {/* First set */}
            {partners.map((partner, index) => (
              <div
                key={`partner-1-${index}`}
                className="flex-shrink-0 w-48 h-24 bg-background/50 rounded-xl flex items-center justify-center border border-white/5 hover:border-[hsl(var(--accent))]/30 transition-colors p-4"
                data-testid={`partner-logo-${index}`}
              >
                {partner.logo ? (
                  <img
                    src={partner.logo}
                    alt={partner.name}
                    className={`max-w-full max-h-full object-contain ${partner.invert ? "brightness-0 invert" : ""}`}
                  />
                ) : (
                  <span className="text-muted-foreground font-medium">{partner.name}</span>
                )}
              </div>
            ))}
            {/* Duplicate for seamless loop */}
            {partners.map((partner, index) => (
              <div
                key={`partner-2-${index}`}
                className="flex-shrink-0 w-48 h-24 bg-background/50 rounded-xl flex items-center justify-center border border-white/5 hover:border-[hsl(var(--accent))]/30 transition-colors p-4"
              >
                {partner.logo ? (
                  <img
                    src={partner.logo}
                    alt={partner.name}
                    className={`max-w-full max-h-full object-contain ${partner.invert ? "brightness-0 invert" : ""}`}
                  />
                ) : (
                  <span className="text-muted-foreground font-medium">{partner.name}</span>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Mini Case Snippet */}
        <div className="mt-16 bg-background/50 rounded-2xl p-8 md:p-12 border border-white/5">
          <div className="max-w-3xl mx-auto text-center">
            <h3 className="text-2xl font-bold mb-4">Vertrauen durch Erfahrung</h3>
            <p className="text-muted-foreground leading-relaxed">
              Von der Konzeption bis zur finalen Auslieferung – ich arbeite eng mit meinen Kunden zusammen, um außergewöhnliche Ergebnisse zu erzielen. Ob als Solo-Producer, DoP, Editor oder Creative Director: Ich bringe Expertise und Vision in jedes Projekt ein.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Partners;
